import type {CardResult, _CardResult} from './card-result';
import type {Card} from './card';
import type {Filter} from './../../compute/filtering/filter';
import type {Series} from './common/series';
import type {SplitBySpec} from './../models/split-by-spec';
import type {_MultivariateCard} from './multivariate-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.ParallelCoordinatesPlotCard
 */
export interface ParallelCoordinatesPlotCard extends _MultivariateCard {
    colorBy?: SplitBySpec | null;
    highlightFilter?: Filter | null;
    maxNumberOfPoints: number;

    // PolyJson type
    type: 'parallel_coordinates_plot';
}

export namespace ParallelCoordinatesPlotCard {
    export const type = 'parallel_coordinates_plot';
}

/** @deprecated Use Card.isParallelCoordinatesPlotCard() */ export function isParallelCoordinatesPlotCard(toTest: Card): toTest is ParallelCoordinatesPlotCard { return ParallelCoordinatesPlotCard.type === toTest['type']; }

export namespace ParallelCoordinatesPlotCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.ParallelCoordinatesPlotCard$ParallelCoordinatesPlotCardResult
     */
    export interface ParallelCoordinatesPlotCardResult extends _CardResult {
        groups: Filter[];
        parallelCoordinates: ParallelCoordinatesPlotCard.ParallelCoordinates[];

        // PolyJson type
        type: 'parallel_coordinates_plot';
    }

    export namespace ParallelCoordinatesPlotCardResult {
        export const type = 'parallel_coordinates_plot';
    }

    /** @deprecated Use CardResult.isParallelCoordinatesPlotCardResult() */ export function isParallelCoordinatesPlotCardResult(toTest: CardResult): toTest is ParallelCoordinatesPlotCardResult { return ParallelCoordinatesPlotCardResult.type === toTest['type']; }

    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.ParallelCoordinatesPlotCard$ParallelCoordinates
     */
    export interface ParallelCoordinates {
        columnSeries: Series[];
        groupIndex: number;
        isHighlighted: boolean;
    }
}